import type { Role } from '@dnx/domain';

export const ROLE_LABELS: Record<Role, string> = {
  org_admin: 'Administração',
  unit_manager: 'Gestão da unidade',
  doctor: 'Médico(a)',
  nurse: 'Enfermagem',
  sales: 'Comercial',
  reception: 'Recepção',
  finance: 'Financeiro',
};

export const roleLabel = (r: string) => ROLE_LABELS[r as Role] ?? r;

export function greeting(date = new Date()): string {
  const h = Number(new Intl.DateTimeFormat('pt-BR', { hour: 'numeric', hour12: false, timeZone: 'America/Sao_Paulo' }).format(date));
  if (h < 12) return 'Bom dia';
  if (h < 18) return 'Boa tarde';
  return 'Boa noite';
}

export const todayLong = () =>
  new Intl.DateTimeFormat('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'America/Sao_Paulo' }).format(new Date());

export const initials = (name: string) =>
  name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]!.toUpperCase()).join('');

export const STAGE_LABELS: Record<string, string> = {
  new: 'Novo', qualifying: 'Em qualificação', evaluation_scheduled: 'Avaliação agendada', evaluated: 'Avaliado',
  quoted: 'Orçamento enviado', won: 'Fechado', lost: 'Perdido',
};
export const STAGE_DOT: Record<string, string> = {
  new: 'bg-info', qualifying: 'bg-primary', evaluation_scheduled: 'bg-accent', evaluated: 'bg-warning',
  quoted: 'bg-[oklch(0.55_0.15_300)]', won: 'bg-success', lost: 'bg-fg-subtle',
};
export const SOURCE_LABELS: Record<string, string> = {
  whatsapp: 'WhatsApp', meta_ads: 'Anúncio Meta', google_ads: 'Google Ads', instagram: 'Instagram', site: 'Site',
  referral: 'Indicação', walk_in: 'Balcão', phone: 'Telefone', other: 'Outra',
};
export const AREA_LABELS: Record<string, string> = { scalp: 'Couro cabeludo', eyebrow: 'Sobrancelha', beard: 'Barba', other: 'Outro' };
export const LOST_LABELS: Record<string, string> = {
  price: 'Preço', no_response: 'Parou de responder', not_candidate: 'Sem indicação médica', competitor: 'Fechou com outra clínica',
  timing: 'Não é o momento', other: 'Outro motivo',
};
export const daysAgo = (iso: string) => {
  const d = Math.floor((Date.now() - new Date(iso).getTime()) / 86_400_000);
  return d === 0 ? 'hoje' : d === 1 ? 'há 1 dia' : `há ${d} dias`;
};
